export const WorksheetDrawerTestIds = {
  DRAWER: 'worksheet-drawer',
  FORM: 'worksheet-drawer.form',
  SAVE_DRAFT_BUTTON: 'worksheet-drawer.save-draft-button',
  COMPLETE_BUTTON: 'worksheet-drawer.complete-button',
  PRINT_BUTTON: 'worksheet-drawer.print-button',
};
